import { setPageLevelDataCapture, Reporter } from 'features/dataCapture';
import { domReady } from 'utilities/dom';
import getRecommendedItems from 'features/certona/desktop';

import initNoCookiesOverlay from '../../noCookiesOverlay';

if (window.resx) {

	window.resx.prodDetailCertonaSkusUsed = [];

}

window.lp.certona.getRecommendedItems = getRecommendedItems;

if (window.lp.globals.enableDataCapture) {

	setPageLevelDataCapture();
	window.lp.dataCapture.reporter = new Reporter();

}

domReady(() => {

	if (window.lp.globals.canShowCertona) {

		window.lp.certona.getRecommendedItems();

	}

	initNoCookiesOverlay();

});
